import {InjectionToken} from '@angular/core';

export const MSAL_INSTANCE = new InjectionToken<string>('MSAL_INSTANCE');

export const PROCESS_LOGIN_PATH = 'login/process';
export const PASSWORD_RESET_PATH = 'passwordreset';
